import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import configs from './index';

const sentryIgnoreErrors: string[] = [
    // Ignore Safari browser errors
    'ResizeObserver loop limit exceeded',
    "Unexpected token '<'",
    // Google Maps errors
    "Argument 1 ('target') to IntersectionObserver.observe must be an instance of Element",
    "undefined is not an object (evaluating 'o.lat')",
    'this.Vh.close is not a function',
    "this.Xh.close is not a function. (In 'this.Xh.close()', 'this.Xh.close' is undefined)",
];

function filterSentryErrors(event, hint) {
    const error = hint.originalException;

    if (error) {
        console.log('beforeSend - Sentry error', error);
    } else {
        console.log('beforeSend - Sentry error: Original exception is null or undefined');
    }

    if (error?.isAxiosError) {
        if (error.response) {
            const { status, config } = error.response;
            const { url } = config;

            if (status === 404 && url.includes('/api/contract/unsigned')) {
                console.log('Not Sent to Sentry');
                return null; // Do not send this error to Sentry
            }
        }
    }

    if (event?.extra?.arguments) {
        console.log('arguments before', event.extra.arguments);
        // eslint-disable-next-line no-param-reassign
        event.extra.arguments = event.extra.arguments.map((arg) => {
            if (typeof arg === 'object' && arg !== null) {
                try {
                    return JSON.stringify(arg, null, 2); // Pretty-print JSON
                } catch (e) {
                    return '[Unserializable Object]';
                }
            }
            return arg;
        });
        console.log('arguments after', event.extra.arguments);
        return event;
    }

    return event;
}

export function initializeSentry(): void {
    if (configs.appConfig.useSentry) {
        const sentryDns: string = process.env.REACT_APP_SENTRY_DNS;
        Sentry.init({
            dsn: sentryDns,
            integrations: [new Integrations.BrowserTracing()],
            release: `rider-webapp@${process.env.REACT_APP_VERSION}`,
            environment: process.env.REACT_APP_ENVIRONMENT,
            // for now all errors are remoted, adjust the ratio for finer control
            tracesSampleRate: 0.2,
            ignoreErrors: sentryIgnoreErrors,
            maxValueLength: 8000,
            beforeSend(event, hint) {
                return filterSentryErrors(event, hint);
            },
        });
    }
}
